import { graphql } from '@/gql';
import { queryExecute } from '@/Utils/graphqlAPI';

type FindCallerPhoneNumberByPreAuthorizationNumberInput = {
  partnerId: number;
  preAuthorizationNumber: string;
};

export const findCallerPhoneNumberByPreAuthorizationNumber = async ({
  partnerId,
  preAuthorizationNumber,
}: FindCallerPhoneNumberByPreAuthorizationNumberInput) => {
  const response = await queryExecute({
    query: graphql(`
      query FindCallerPhoneNumberByPreAuthorizationNumber($partnerId: Float!, $preAuthorizationNumber: String!) {
        findCallerPhoneNumberByPreAuthorizationNumber(partnerId: $partnerId, preAuthorizationNumber: $preAuthorizationNumber)
      }
    `),
    variables: {
      preAuthorizationNumber,
      partnerId,
    },
    fetchPolicy: 'no-cache',
  });

  return response.data.findCallerPhoneNumberByPreAuthorizationNumber;
};
